import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { PATH_CHANGE_PASSWORD } from 'routing/path'
import logOutUserAction from 'actions/admin-user/action.user-log-out'
import { getTranslations } from 'store/admin-translation/reducer.translations'
import { getCurrentUser } from 'store/admin-user/reducer.user-get-current'

const Navbar = () => {
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const mounted = useRef(false);
  useEffect(() => {
      mounted.current = true;
      return () => { mounted.current = false; };
  }, []);

  const dispatch = useDispatch()
  const translations = useSelector(getTranslations)
  const user = useSelector(getCurrentUser)
  
  const handleSubmit = () => {
    setSubmitEnabled(false);
    setTimeout(() => mounted.current && setSubmitEnabled(true), 1000);

    dispatch(logOutUserAction(translations));
  };

  const userName = user ? user.firstName + " " + user.lastName : "";
  return (
    <nav className="navbar navbar-top navbar-expand navbar-dashboard navbar-dark pl-0 pr-2 pb-0">
      <div className="container-fluid px-0">
        <div className="d-flex justify-content-between w-100" id="navbarSupportedContent">
          <div className="d-flex">
          </div>
          <ul className="navbar-nav align-items-center">
            <li className="nav-item dropdown">
              <div className="nav-link dropdown-toggle pt-1 px-0" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="media d-flex align-items-center">
                  <FontAwesomeIcon icon={faUserCircle} className="user-image-fa" size="lg" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{userName}</span>
                  </div>
                </div>
              </div>
              <div className="dropdown-menu dashboard-dropdown dropdown-menu-end mt-2 py-0">
                <Link className="dropdown-item rounded-top fw-bold" to={PATH_CHANGE_PASSWORD}>{translations.changePassword}</Link>
                <div role="separator" className="dropdown-divider my-0"></div>
                <Formik
                  initialValues={() => {}}
                  onSubmit={() => { handleSubmit() }}>
                  {() => (<Form>
                    <button id="signOutButton" type="submit" className="dropdown-item rounded-bottom fw-bold" disabled={submitEnabled ? null : 'disabled'}><FontAwesomeIcon icon={faSignOutAlt} /> {translations.signOut}</button>
                  </Form>)}
                </Formik>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
